import { nextQuestion } from "./nextQuestion";
const nextQuestionSlug = ({ question, questions }) => {
    const next = nextQuestion({ question, questions });
    return next?.metadata.slug;
};
export { nextQuestionSlug };
